import Vue from 'vue';
import App from './App';
import router from './router';
import {store} from './store';

import * as uiv from 'uiv';

import 'vue-awesome/icons/flag';
import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon';
import Affix from 'vue-affix';
import VueScrollactive from 'vue-scrollactive';

Vue.component('icon', Icon);

Vue.use(uiv);

Vue.use(Affix);

Vue.use(VueScrollactive);

import "./assets/scss/app.scss";
Vue.config.productionTip = false;

new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  created () {
    window.vue = this;
  },
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js